import { logger, Logger } from "../../analytics/logger";

/** The client for analytics API calls. */
export interface AnalyticsClient {
  logger: Logger;
}

export const analyticsClient: AnalyticsClient = {
  logger,
};
